<template>
  <div>
    <el-row class="el-row--wrap" v-if="loaded" type="flex" justify="center" :gutter="20">
      <el-col :lg="8" :sm="12" :xs="24">
        <License @input="newLicense"/>
      </el-col>
      <el-col :lg="8" :sm="12" :xs="24">
        <User @input="newUser"/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";
import env from "@/environments/environment";
import License from "@/components/License.vue";
import User from "@/components/User.vue";
export default {
  name: "Licenses",
  components: {
    License,
    User
  },
  data() {
    return {
      loaded: false
    };
  },
  methods: {
    async newLicense({ 
      holder, 
      holderName, 
      name, 
      street, 
      houseNumber, 
      postCode, 
      city, 
      country, 
      lat, 
      lon 
    }) {
      try {
        const {
          data: { license }
        } = await axios.post(`${env.url}/admin/license/user/${holder}`, {
          name: name, 
          street: street, 
          houseNumber: houseNumber, 
          postCode: postCode, 
          city: city, 
          country: country,
          lat: lat, 
          lon: lon 
        });
        this.$alert(
          `${this.$t('licensecreatedcorrectly')} <strong><code>${name}</code></strong> ${this.$t('foruser')} <em>${holderName}</em>.<br/>
          ${this.$t('key')} <strong><code>${license.key}</code></strong>`,
          `${this.$t('success')}`,
          {
            dangerouslyUseHTMLString: true,
            roundButton: true
          }
        );
      } catch (e) {
        console.log("failed to send request", e);
      }
    },
    async newUser({ username, password }) {
      try {
        const {
          data: { user }
        } = await axios.post(`${env.url}/admin/users`, {
          username,
          password
        });
        this.$alert(
          `${this.$t('usercreatedcorrectly')} <em>${username}</em>.`,
          `${this.$t('success')}`,
          {
            dangerouslyUseHTMLString: true,
            roundButton: true
          }
        );
      } catch (e) {
        if (e && e.response && e.response.status === 409) {
          this.$alert(
            `${this.$t('userrnamed')} <em>${username}</em> ${this.$t('alreadyexist')}`,
            `${this.$t('error')}`,
            {
              dangerouslyUseHTMLString: true,
              roundButton: true
            }
          );
        } else {
          this.$alert(`${this.$t('unknownerror')}`, `${this.$t('error')}`, {
            roundButton: true
          });
          console.log(e);
        }
      }
    }
  },
  created() {
    if (!axios.defaults.headers["X-Master-Key"]) {
      this.$router.replace("/admin");
      return;
    }

    this.loaded = true;
  }
};
</script>
